// extracted by mini-css-extract-plugin
export default {"row":"registrationAddress_row__5kR9r","label":"registrationAddress_label__Wn1pH","address":"registrationAddress_address__alzPr"};